import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import { history } from 'src/lib/history';

import ErrorMessage from 'src/views/components/ErrorMessage';

import Admin from './Admin';
import AllRulesOverview from './AllRulesOverview';
import FeatureFlags from './FeatureFlags';
import IssueSidebar from './IssueSidebar';
import OauthBegin from './OauthBegin';
import OauthCallback from './OauthCallback';
import PagerDuty from './PagerDuty';
import ProjectSettings from './ProjectSettings';

const Main = () => (
  <Router history={history}>
    <Switch>
      <Route path="/integration-jira-ui/issue_sidebar" component={IssueSidebar}/>
      <Route path="/integration-jira-ui/settings" component={Admin}/>
      <Route path="/integration-jira-ui/project_settings" component={ProjectSettings}/>
      <Route path="/integration-jira-ui/feature_flags" component={FeatureFlags}/>
      <Route path="/integration-jira-ui/all_rules_overview" component={AllRulesOverview}/>
      <Route path="/integration-jira-ui/oauth/begin" component={OauthBegin}/>
      <Route path="/integration-jira-ui/oauth/callback" component={OauthCallback}/>
      <Route path="/integration-jira-ui/pagerduty" component={PagerDuty}/>
      <Route>
        <ErrorMessage error={['Unknown location', 'Please use this UI only in the context of Jira iframe']}/>
      </Route>
    </Switch>
  </Router>
);

export default Main;
